import React from "react";

const Widget = ({children,className, height='h-full'}) => {
  return <div className={`w-full ${height} px-3 pt-3 bg-white rounded-lg ${className}`} style={{ boxShadow: "0px 4px 50px 0px #0000001A" }}>{children}</div>;
};

export default Widget;
